const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "nsfoki3sca",
  x1: "0%",
  x2: "92.718%",
  y1: "37.461%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FCB961"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#EB38C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1EC1FE"
})));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#nsfoki3sca)",
  fillOpacity: 0.78,
  fillRule: "evenodd",
  d: "M266.118.011h19.279c146.701 0 265.625 118.924 265.625 265.625v19.279c0 146.701-118.924 265.625-265.625 265.625h-19.279C119.417 550.54.492 431.616.492 284.915v-19.279C.492 118.935 119.417.011 266.118.011z"
});
function SvgCrcle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552,
    height: 551,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrcle);
export default __webpack_public_path__ + "static/media/crcle.bab3e41d100ff4f02f75f8a178be2959.svg";
export { ForwardRef as ReactComponent };